module.exports =
  '_ANALYSIS':
    'TITLE': 'Analysis'
    'UPGRADE':
      'COURSE_STATS': 'Course Stats'
      'SCATTER': 'Distribution map of your target of scoring'
      'MESSAGE': 'Upgrade to GN+ addict member to track more stats, Edit your score data on the web, Access Concierge service, and more.'
      'UPGRADE_NOW': 'Upgrade Now'
    'PERIOD_FILTER':
      'ENTIRE_PERIOD': 'Entire Period'
      'LAST_3_MONTHS': 'Last 3 months'
      'LAST_6_MONTHS': 'Last 6 months'
      'CUSTOM_RANGE_LABEL': 'Custom Range'
      'APPLY_LABEL': 'Apply'
      'CANCEL_LABEL': 'Cancel'
      'TARGET_RANGE': 'Period'
      'TARGET_ROUND': 'Target round'
      'INCLUDE_1_5': 'Include 1.5 Round'
      'EXCLUDE_1_5': 'Exclude 1.5 Round'
      'INCLUDE_0_5': 'Include 0.5 Round'
      'EXCLUDE_0_5': 'Exclude 0.5 Round'
      'INCLUDE_1_5_SP': 'Include 1.5R'
      'EXCLUDE_1_5_SP': 'Exclude 1.5R'
      'INCLUDE_0_5_SP': 'Include 0.5R'
      'EXCLUDE_0_5_SP': 'Exclude 0.5R'
    'DETAILED_ANALYSIS':
      'MY_DATA': "MY DATA"
      'GOAL': "Goal"
      'MY_AVG': "Average"
      'BEST_SCORE': "Best Score Round"
      'WORST_SCORE': "Worst Score Round"
      'ALL_MEMBERS': "All User's Avg. Data"
      'AVG_TOTAL_SCORE_TITLE': "Average Total Score (Only completed 18H rounds)"
      'NUMBER_OF_ROUNDS': "Number of Rounds"
      'AVG_TOTAL_SCORE': "Average Total Score"
      'PUTT_TITLE': "Putt Analysis"
      'AVG_PUTT': "Avg. Putts"
      'RAT_AVG_PUTT': "GIR. Avg. Putts"
      'RAT_FAIRWAY_TITLE': "Driving Accuracy"
      'FAIRWAY_CENTER': "Fairway hit (%)"
      'FAIRWAY_RIGHT': "Missed right (%)"
      'FAIRWAY_LEFT': "Missed left (%)"
      'GIR_ANALYSIS_TITLE': "GIR Analysis"
      'RAT_PAR_ON': "GIR (%)"
      'RAT_BOGEY_ON': "GIR+1 (%)"
      'STROKE_ANALYSIS_TITLE': "Stroke Analysis"
      'AVG_STROKE_PAR3': "Avg. Stroke (Par 3)"
      'AVG_STROKE_PAR4': "Avg. Stroke (Par 4)"
      'AVG_STROKE_PAR5': "Avg. Stroke (Par 5)"
      'RAT_RECOVERY': "Recovery (%)"
      'SCORE_ANALYSIS_TITLE': 'Score Analysis'
      'RAT_UNDER_EAGLE': "Eagle or under (%)"
      'RAT_BIRDIE': "Birdie (%)"
      'RAT_PAR': "Par (%)"
      'RAT_BOGEY': "Bogey (%)"
      'RAT_DBOGEY': "Double Bogey (%)"
      'RAT_OVER_TBOGEY': "Triple Bogey or over (%)"
      'SAND_SAVES_TITLE': "Guard Bunker"
      'RAT_SAND_SAVE': "Scrambling from the Sand (%)"
    'SCATTER_CHART':
      'SCORE': 'SCORE'
      'PUTT': 'PUTT'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/i18n/en.coffee